<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class=" bg-blue-950 dark:bg-slate-900  print:hidden" [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation?.default"
    [opened]="isScreenSmall ? open : true" (openedChanged)="onOpenedChange($event)">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center justify-center">
            <div [ngClass]="{'text-[90%]': navigationAppearance == 'dense', 'text-[2rem]': navigationAppearance == 'default'}"
                class="m-auto  leading-none  font-semibold  tracking-tight flex-wrap">
                <span class="text-orange-600">Tchau</span>
                <span class="text-white">Usado</span>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <div class="flex items-center space-x-2 pr-2">



            <!-- Navigation toggle button
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            -->
            <!-- Navigation appearance toggle button -->
            <button class="inline-flex" mat-icon-button (click)="toggleNavigationAppearance()">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>

            <div>
                <h1 class="font-bold text-xl">{{activeRoute?.title}}</h1>
                <h3 class="text-sm text-gray-600 dark:text-white/75">{{activeRoute?.text}}</h3>
            </div>
        </div>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <notifications></notifications>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div *ngIf="!isChatRoute"
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden">
        <span class="text-secondary font-medium">TchauUsado &copy; {{ currentYear }}</span>
    </div>
</div>

<!-- Quick chat
<quick-chat #quickChat="quickChat"></quick-chat>
-->